/**
 * Created by shiyonggao on 2019/11/28.
 */
const tips = {
    operateSuccessMsg: '操作成功！',
    title: '提示'
};

class message {

    /***
     * 操作成功
     */
    message(args, {state, commit, dispatch, rootState}) {
        let message = args.message ? args.message: tips.operateSuccessMsg;
        let options = {
            message: message,
            onClose(){
                commit('PRIVATE_LOADING', false, {root: true});

                /**回调方法**/
                if (typeof args.callback === 'function') {
                    args.callback(args);
                }
                /**自动刷新**/
                if (args.reload) {
                    window.location.href = window.location.href;
                }
            }
        };
        rootState.$vue.$message(options);
    }

    /***
     * 操作成功
     */
    alert(args, {state, commit, dispatch, rootState}) {
        let message = args.message ? args.message : tips.operateSuccessMsg;
        let reload = args.reload !== undefined ? args.reload: false;
        let options = {
            callback: ()=> {
                commit('PRIVATE_LOADING', false, {root: true});

                /**回调方法**/
                if (typeof args.callback === 'function') {
                    args.callback(args);
                }
                /**自动刷新**/
                if(args.reload) {
                    window.location.href = window.location.href;
                }
            }
        };
        rootState.$vue.$alert(message, tips.title, options);
    }

}

export default new message();



// WEBPACK FOOTER //
// ./website/helper/message.js